import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wol-mainlayout',
  templateUrl: './mainlayout.component.html',
  styleUrls: ['./mainlayout.component.scss']
})
export class MainlayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
